const XOR = (a, b) => a ^ b;
export default XOR;
